<template>
  <div class="flex justify-center items-center w-screen h-screen">
    <div class="w-4/5 -mt-24">
      <div class="w-1/2 xs:w-4/5 m-auto">
        <!-- eslint-disable-next-line -->
        <img src="@/assets/svg/logo-soactiv.svg" alt="logo" />
      </div>
      <p class="mt-20 text-4xl xs:text-2xl font-bold">
        Ce site est en maintenance
      </p>
      <p class="text-2xl xs:text-xl mt-8">Nous serons bientôt de retour</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
}
</script>
